import React from "react";
import "./WelcomeScreen.css";
function WelcomeScreen(props) {
  return props.showWelcomeScreen ? (
    <div className="WelcomeScreen">
      <h1>Welcome to the Meet app</h1>
      <h4>Log in to see events for full-stack developer nearby.</h4>
      <p>
        This application is built with React, using Google's calender API.{" "}
        <br /> Upon authentication with oAuth 2.0 you can access the read only
        calender of CareerFoundry and search for events in different locations.
        <br /> You can limit the number of events displayed between 1 to 32
        events by entering the respective number. <br />
        No data will be recorded or stored in any way.
        <br />
        This application is designed only for showing my coding skills.
      </p>
      <div className="button_cont" align="center">
        <div class="google-btn">
          <div class="google-icon-wrapper">
            <img
              class="google-icon"
              src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Log
o.svg"
              alt="Google sign-in"
            />
          </div>
          <button
            onClick={() => {
              props.getAccessToken();
            }}
            rel="nofollow noopener"
            class="btn-text"
          >
            <b>Sign in with google</b>
          </button>
        </div>
      </div>
      <a
        href="https://ceto-hub.github.io/meetUp/privacy.html"
        rel="nofollow noopener"
      >
        Privacy policy
      </a>
    </div>
  ) : null;
}
export default WelcomeScreen;
